<div class="error-page content85percent">
  <h2 class="error-page__title">{{ heading }}</h2>
  <p class="error-page__message">{{ errorMessage }}</p>
  <button
    type="button"
    class="btn btn-primary"
    (click)="goBack()">
    Go back
  </button>
</div>
